"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Counter = _interopRequireDefault(require("../Counter/Counter"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Menu = _interopRequireDefault(require("../Menu/Menu"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SearchInput = _interopRequireDefault(require("../SearchInput/SearchInput"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _button = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/button.css") : void 0);

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _menu = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/menu.css") : void 0);

var _productSwitch = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/product-switch.css") : void 0);

var _shellbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/shellbar.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _menu.default), _icon.default), _productSwitch.default), _shellbar.default));
var isUsingCssModules = _shellbar.default && (0, _keys.default)(_shellbar.default).length > 0;
var buttonClassnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _button.default);
/** The **Shellbar** offers consistent, responsive navigation across all products and applications. Includes
support for branding, product navigation, search, notifications, user settings, and CoPilot. This is
a composite component comprised of mandatory and optional elements. Before getting started, here are
some things to know. */

var _ref = /*#__PURE__*/_react.default.createElement("img", {
  alt: "SAP",
  src: "//unpkg.com/fundamental-styles/dist/images/sap-logo.png"
});

var _ref2 = /*#__PURE__*/_react.default.createElement("img", {
  alt: "CoPilot",
  height: "30",
  src: "//unpkg.com/fundamental-styles/dist/images/copilot.png",
  width: "30"
});

var Shellbar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Shellbar, _Component);

  var _super = _createSuper(Shellbar);

  function Shellbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Shellbar);
    _this = _super.call(this, props);

    _this.backBtnHandler = function () {
      _this.setState({
        showCollapsedProductSwitchMenu: false
      });
    };

    _this.getCollapsedActions = function () {
      var collapsedList = []; //put all the Additional Actions in the list

      if (_this.props.actions) {
        collapsedList = (0, _toConsumableArray2.default)(_this.props.actions);
      } //Add the notification icon to the notifications object and add it to the list
      //The notifications are placed after the additional actions


      if (_this.props.notifications) {
        var collapsedNotifications = _this.props.notifications;
        collapsedNotifications.glyph = 'bell';
        collapsedList.push(collapsedNotifications);
      } //Add the grid icon to the product switch object and add it to the list
      //The product switch is placed after the notifications


      if (_this.props.productSwitch) {
        var collapsedProductSwitch = _this.props.productSwitch; // eslint-disable-next-line react/prop-types

        collapsedProductSwitch.glyph = 'grid'; // eslint-disable-next-line react/prop-types

        collapsedProductSwitch.callback = function () {
          _this.setState(function (prevState) {
            return {
              showCollapsedProductSwitchMenu: !prevState.showCollapsedProductSwitchMenu
            };
          });
        };

        collapsedList.push(collapsedProductSwitch);
      } //Add the search icon to the search input object and add it to the list
      //The search input is placed at the beginning of the list


      if (_this.props.searchInput) {
        var collapsedSearchInput = _this.props.searchInput;
        collapsedSearchInput.glyph = 'search';
        collapsedList.unshift(collapsedSearchInput);
      }

      return collapsedList;
    };

    _this.getNotificationsSum = function () {
      var additionalActionsSum = 0;

      if (_this.props.actions) {
        var _context;

        additionalActionsSum = (0, _reduce.default)(_context = _this.props.actions).call(_context, function (r, d) {
          return r + d.notificationCount;
        }, 0);
      }

      if (_this.props.notifications) {
        if (_this.props.notifications.notificationCount) {
          var totalSum = additionalActionsSum + _this.props.notifications.notificationCount;
          return totalSum;
        } else {
          return additionalActionsSum;
        }
      } else {
        return additionalActionsSum;
      }
    };

    _this.state = {
      collapsedActions: _this.getCollapsedActions(),
      totalNotifications: _this.getNotificationsSum(),
      showCollapsedProductSwitchMenu: false
    };
    return _this;
  }

  (0, _createClass2.default)(Shellbar, [{
    key: "render",
    value: function render() {
      var _context2, _classnames3, _searchInput$popoverP, _searchInput$popoverP2, _context4;

      var _this$props = this.props,
          localizedText = _this$props.localizedText,
          logo = _this$props.logo,
          logoSAP = _this$props.logoSAP,
          productTitle = _this$props.productTitle,
          productMenu = _this$props.productMenu,
          subtitle = _this$props.subtitle,
          copilot = _this$props.copilot,
          searchInput = _this$props.searchInput,
          size = _this$props.size,
          actions = _this$props.actions,
          notifications = _this$props.notifications,
          productSwitch = _this$props.productSwitch,
          productSwitchList = _this$props.productSwitchList,
          profile = _this$props.profile,
          profileMenu = _this$props.profileMenu,
          popoverPropsFor = _this$props.popoverPropsFor,
          className = _this$props.className,
          cssNamespace = _this$props.cssNamespace,
          backAction = _this$props.backAction;
      var shellbarClasses = classnames("".concat(cssNamespace, "-shellbar"), className, (0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-shellbar--")).call(_context2, size), size));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: shellbarClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__group"), "".concat(cssNamespace, "-shellbar__group--product"))
      }, backAction && /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-label": localizedText.backButtonLabel,
        className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
        glyph: "nav-back",
        onClick: backAction,
        option: "transparent"
      }), logo && /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-shellbar__logo"))
      }, logo), logoSAP && /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-shellbar__logo"))
      }, _ref), productTitle && !productMenu && /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-shellbar__title"))
      }, productTitle), productMenu && /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.productMenu, {
        body: productMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, null, /*#__PURE__*/_react.default.createElement(_Menu.default.List, null, (0, _map.default)(productMenu).call(productMenu, function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
            key: index,
            link: item.link,
            onClick: item.callback,
            url: item.url
          }, item.glyph && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            glyph: item.glyph,
            size: item.size
          }), "\xA0\xA0\xA0"), item.name);
        }))),
        control: /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: classnames("".concat(cssNamespace, "-shellbar__button--menu"), "".concat(cssNamespace, "-button--menu"), (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-button"), isUsingCssModules), (0, _defineProperty2.default)(_classnames3, buttonClassnames("".concat(cssNamespace, "-button--menu")), isUsingCssModules), _classnames3)),
          glyph: "megamenu",
          iconProps: {
            className: classnames("".concat(cssNamespace, "-shellbar__button--icon"))
          },
          option: "transparent",
          textClassName: classnames("".concat(cssNamespace, "-shellbar__title"))
        }, productTitle),
        noArrow: true,
        popperProps: {
          id: "".concat(cssNamespace, "-shellbar-product-popover")
        }
      })), subtitle && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__subtitle"))
      }, subtitle)), copilot ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__group"), "".concat(cssNamespace, "-shellbar__group--copilot"))
      }, _ref2) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__group"), "".concat(cssNamespace, "-shellbar__group--actions"))
      }, searchInput && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--desktop"))
      }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
        className: classnames("".concat(cssNamespace, "-shellbar__input-group")),
        inShellbar: true,
        inputGroupAddonProps: {
          className: classnames("".concat(cssNamespace, "-shellbar__input-group__addon"))
        },
        inputGroupProps: {
          className: classnames("".concat(cssNamespace, "-shellbar__input-group"))
        },
        inputProps: {
          className: classnames("".concat(cssNamespace, "-shellbar__input-group__input"))
        },
        onEnter: searchInput.onSearch,
        placeholder: searchInput.placeholder,
        popoverProps: _objectSpread({
          placement: (searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$popoverP = searchInput.popoverProps) === null || _searchInput$popoverP === void 0 ? void 0 : _searchInput$popoverP.placement) || 'bottom',
          disableEdgeDetection: (searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$popoverP2 = searchInput.popoverProps) === null || _searchInput$popoverP2 === void 0 ? void 0 : _searchInput$popoverP2.disableEdgeDetection) || true
        }, searchInput.popoverProps),
        searchBtnProps: {
          className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules))
        },
        searchList: searchInput.searchList
      })), actions && (0, _map.default)(actions).call(actions, function (action, index) {
        var _context3;

        return /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--desktop")),
          key: index
        }, action.menu ? /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
          placement: "bottom-end"
        }, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.actionMenu, {
          body: action.menu,
          control: /*#__PURE__*/_react.default.createElement(_Button.default, {
            "aria-label": action.label,
            className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
            glyph: action.glyph,
            iconBeforeText: true
          }, action.notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_Counter.default, {
            "aria-label": localizedText.counterLabel,
            className: classnames("".concat(cssNamespace, "-shellbar__counter--notification")),
            notification: true
          }, action.notificationCount)),
          popperProps: {
            id: (0, _concat.default)(_context3 = "".concat(cssNamespace, "-shellbar-actions-popover-")).call(_context3, index)
          }
        })) : /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": action.label,
          className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
          glyph: action.glyph,
          iconBeforeText: true,
          key: index,
          onClick: action.callback
        }, action.notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_Counter.default, {
          "aria-label": localizedText.counterLabel,
          notification: true
        }, action.notificationCount)));
      }), notifications && (notifications.notificationsBody || notifications.noNotificationsBody ? /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
        placement: "bottom-end"
      }, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.notifications, {
        body: notifications.notificationCount > 0 && notifications.notificationsBody || notifications.notificationCount <= 0 && notifications.noNotificationsBody,
        control: /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--desktop"))
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": localizedText.notificationsButton,
          className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
          glyph: "bell",
          iconBeforeText: true
        }, notifications.notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_Counter.default, {
          "aria-label": localizedText.counterLabel,
          notification: true
        }, notifications.notificationCount))),
        popperProps: {
          id: "".concat(cssNamespace, "-shellbar-notifications-popover")
        }
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--desktop"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-label": localizedText.notificationsButton,
        className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
        glyph: "bell",
        iconBeforeText: true,
        onClick: notifications.callback
      }, notifications.notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_Counter.default, {
        "aria-label": localizedText.counterLabel,
        notification: true
      }, notifications.notificationCount)))), (actions || searchInput || notifications) && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--mobile"))
      }, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
        placement: "bottom-end"
      }, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.collapsedMobileMenu, {
        body: /*#__PURE__*/_react.default.createElement(_Menu.default, null, !this.state.showCollapsedProductSwitchMenu ? /*#__PURE__*/_react.default.createElement(_Menu.default.List, null, (0, _map.default)(_context4 = this.state.collapsedActions).call(_context4, function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
            key: index,
            link: item.link,
            onClick: item.callback,
            url: item.url
          }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            glyph: item.glyph
          }, item.notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_Counter.default, {
            notification: true
          }, item.notificationCount)), " ", item.label);
        })) : /*#__PURE__*/_react.default.createElement(_Menu.default.List, null, /*#__PURE__*/_react.default.createElement(_Menu.default.Item, null, /*#__PURE__*/_react.default.createElement("span", {
          className: classnames("".concat(cssNamespace, "-menu"), 'sap-icon--nav-back'),
          onClick: this.backBtnHandler
        })), (0, _map.default)(productSwitchList).call(productSwitchList, function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
            key: index,
            link: item.link,
            onClick: item.callback,
            url: item.url
          }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            glyph: item.glyph
          }), " ", item.title);
        }))),
        control: /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-shellbar-collapse--control")),
          role: "button"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: classnames("".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
          glyph: "overflow",
          iconBeforeText: true
        }, /*#__PURE__*/_react.default.createElement(_Counter.default, {
          "aria-label": localizedText.counterLabel,
          notification: true
        }, " ", this.state.totalNotifications > 0 && this.state.totalNotifications, " "))),
        popperProps: {
          id: "".concat(cssNamespace, "-shellbar-mobile-action-popover")
        }
      }))), profile && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--show-always"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-user-menu"))
      }, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
        placement: "bottom-end"
      }, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.profileMenu, {
        body: profileMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, null, /*#__PURE__*/_react.default.createElement(_Menu.default.List, null, /*#__PURE__*/_react.default.createElement(_Menu.default.Item, null, profile.userName), (0, _map.default)(profileMenu).call(profileMenu, function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_Menu.default.Item, {
            key: index,
            link: item.link,
            onClick: item.callback,
            url: item.url
          }, item.glyph && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            glyph: item.glyph,
            size: item.size
          }), "\xA0\xA0\xA0"), item.name);
        }))),
        control: /*#__PURE__*/_react.default.createElement("button", {
          className: classnames("".concat(cssNamespace, "-button"), "".concat(cssNamespace, "-shellbar__button"), "".concat(cssNamespace, "-shellbar__button--user-menu"), (0, _defineProperty2.default)({}, buttonClassnames("".concat(cssNamespace, "-button")), isUsingCssModules))
        }, profile.image ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
          backgroundImageUrl: profile.image,
          circle: true,
          className: classnames("".concat(cssNamespace, "-shellbar__avatar--circle")),
          size: "xs"
        }) : /*#__PURE__*/_react.default.createElement(_Avatar.default, {
          circle: true,
          className: classnames("".concat(cssNamespace, "-shellbar__avatar--circle")),
          color: profile.colorAccent,
          size: "xs"
        }, profile.initials)),
        noArrow: true,
        popperProps: {
          id: "".concat(cssNamespace, "-shellbar-profile-popover")
        }
      })))), productSwitch && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-shellbar__action"), "".concat(cssNamespace, "-shellbar__action--desktop"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-product-switch"))
      }, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
        placement: "bottom-end"
      }, popoverPropsFor === null || popoverPropsFor === void 0 ? void 0 : popoverPropsFor.productSwitch, {
        body: /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-product-switch__body"))
        }, /*#__PURE__*/_react.default.createElement("ul", {
          className: classnames("".concat(cssNamespace, "-product-switch__list"))
        }, (0, _map.default)(productSwitchList).call(productSwitchList, function (item, index) {
          return /*#__PURE__*/_react.default.createElement("li", {
            className: classnames("".concat(cssNamespace, "-product-switch__item"), {
              selected: item.selected
            }),
            key: index,
            onClick: item.callback
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: classnames("".concat(cssNamespace, "-product-switch__icon"), "sap-icon--".concat(item.glyph))
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: classnames("".concat(cssNamespace, "-product-switch__text"))
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: classnames("".concat(cssNamespace, "-product-switch__title"))
          }, item.title), item.subtitle && /*#__PURE__*/_react.default.createElement("div", {
            className: classnames("".concat(cssNamespace, "-product-switch__subtitle"))
          }, item.subtitle)));
        }))),
        control: /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": productSwitch.label,
          className: classnames("".concat(cssNamespace, "-product-switch__control"), "".concat(cssNamespace, "-shellbar__button"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
          glyph: "grid"
        }),
        disableEdgeDetection: true,
        popperProps: {
          id: "".concat(cssNamespace, "-shellbar-product-switch-popover")
        }
      }))))));
    }
  }]);
  return Shellbar;
}(_react.Component);

Shellbar.displayName = 'Shellbar';
process.env.NODE_ENV !== "production" ? Shellbar.propTypes = {
  /** Holds all product actions and links */
  actions: _propTypes.default.array,

  /** Adds back icon to shellbar and performs the provided action */
  backAction: _propTypes.default.func,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** For use with applications that utilize CoPilot */
  copilot: _propTypes.default.bool,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** Aria-label for back <button> */
    backButtonLabel: _propTypes.default.string,

    /** Aria-label for <span> element within the <button> element */
    counterLabel: _propTypes.default.string,

    /** Aria-label for <button> element */
    notificationsButton: _propTypes.default.string
  }),

  /** Provide an img tag for a logo other than the SAP logo.
   * One of the two props (`logo` or `logoSAP`) should be set */
  logo: _propTypes.default.object,

  /** Renders the SAP logo in the Shellbar. One of the two props (`logo` or `logoSAP`) should be set */
  logoSAP: _propTypes.default.bool,

  /** Information about pending notifications */
  notifications: _propTypes.default.object,

  /**
   * Additional props to be spread to the popovers of the action menu, collapsed mobile menu, notifications menu, product menu,
   * product switch popover and the profile menu.
   * */
  popoverPropsFor: {
    actionMenu: _propTypes.default.object,
    collapsedMobileMenu: _propTypes.default.object,
    notifications: _propTypes.default.object,
    productMenu: _propTypes.default.object,
    productSwitch: _propTypes.default.object,
    profileMenu: _propTypes.default.object
  },

  /** Holds product titles and navigation */
  productMenu: _propTypes.default.array,

  /** For navigating between products. An object that contains an accessible and localized label for product switch button. */
  productSwitch: _propTypes.default.shape({
    /** Accessible and localized label for product switch button */
    label: _propTypes.default.string.isRequired
  }),

  /** Array of objects containing data about the products.
   * Callback, title, and glyph are required; selected and subtitle are optional. */
  productSwitchList: _propTypes.default.arrayOf(_propTypes.default.shape({
    callback: _propTypes.default.func.isRequired,

    /** Localized text for the heading */
    title: _propTypes.default.string.isRequired,

    /** The icon to include. See the icon page for the list of icons */
    glyph: _propTypes.default.string.isRequired,

    /** For pre-selecting an item in the product switch list */
    selected: _propTypes.default.bool,
    subtitle: _propTypes.default.string
  })),

  /** Displays the current application when no product menu is used */
  productTitle: _propTypes.default.string,

  /** User information (_e.g._ name, initials, etc.) */
  profile: _propTypes.default.object,

  /** List of items for the profile menu */
  profileMenu: _propTypes.default.array,

  /** Holds `searchInput` [properties](?id=component-api-searchinput--compact&viewMode=docs#properties) */
  searchInput: _propTypes.default.object,

  /** Provides a size modifier for product actions only visible on small shellbar `s`, or product actions only visible on desktop screens `m`/`l`/`xl`. */
  size: _propTypes.default.oneOf(['s', 'm', 'l', 'xl']),

  /** Displays an application context. Should be used rarely */
  subtitle: _propTypes.default.string
} : void 0;
Shellbar.defaultProps = {
  localizedText: {
    backButtonLabel: 'Back button',
    counterLabel: 'Unread count',
    notificationsButton: 'Notifications'
  },
  size: 'l'
};

var _default = (0, _withStyles.default)(Shellbar);

exports.default = _default;